import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["safeSpaceContainer", "safeSpaceInFooter"];

  open() {
    this.safeSpaceContainerTarget.style.display = "flex";
    this.safeSpaceContainerTarget.style.animation = "slideDown 0.5s ease-out";
    this.safeSpaceInFooterTarget.style.display = "none";
    setTimeout(() => {
      // need to set the height on a setTimeout b/c anything below the 100vh mark doesn't show during the slide
      this.safeSpaceContainerTarget.style.height = "100vh";
    }, 500); // same time as the animation's 0.5s
  }

  close() {
    this.safeSpaceContainerTarget.style.height = "unset";
    this.safeSpaceContainerTarget.style.animation = "slideUp 0.5s ease-out";
    this.safeSpaceInFooterTarget.style.display = "unset";
    setTimeout(() => {
      this.safeSpaceContainerTarget.style.display = "none";
    }, 500); // same time as the animation's 0.5s
  }
}
